// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class NewsRollupPlugin {
   static initClass() {
      // @ts-expect-error TS(2339) FIXME: Property 'states' does not exist on type 'NewsRoll... Remove this comment to see the full error message
      this.prototype.states = ['new']
   }
   invoke(data: any, feed: any) {
      const rollup = data.search.rollups.newspaper
      if (rollup && (rollup.documents != null)) {
         const item = {
            documents: rollup.documents,
            type: 'newsRollup',
            query: data.search.query.original_query,
            filters: rollup.filters
         }
         return feed.addPositionalItem(item, rollup.position)
      }
   }
}
NewsRollupPlugin.initClass()

angular.module('summonApp.resultsFeedPlugins')
   .service('newsRollupPlugin', NewsRollupPlugin)
